import request from './request'
import {RES_OK} from './config'

// 获取排行榜
// 1：明星课程；2：明星学员
export function getRankList(type) {
  return request.get('/rank/getlist', {
    params: {
      type
    }
  }).then(({data}) => {
    if (data.code === RES_OK) {
      return data.data
    } else {
      return null
    }
  })
}


// WEBPACK FOOTER //
// ./src/api/rank.js